export default __webpack_public_path__ + "static/Nice-France-credit-KurtBauschardt-1b673432396d0a1b65d9eb71c57dfd12.jpg";